export default __webpack_public_path__ + "static/media/Test4.d9837e74.PNG";